/* Single Product - jQuery variant picker and image slider */
(function ($) {
    function initProduct($section) {
        var $select = $section.find("[data-sp-variant-select]");
        var $atc = $section.find("[data-sp-atc]");
        var $price = $section.find("[data-sp-price]");
        var $compare = $section.find("[data-sp-compare]");
        var $colorLabel = $section.find("[data-sp-selected-color]");
        var $slides = $section.find("[data-slide]");
        var $thumbs = $section.find("[data-sp-thumb]");

        var data = {};
        try {
            data = JSON.parse($section.find("[data-sp-json]").text());
        } catch (e) {}

        var variants = data.variants || [];
        var colorIndex =
            data.colorIndex !== null && data.colorIndex !== undefined
                ? data.colorIndex
                : null;
        var sizeIndex =
            data.sizeIndex !== null && data.sizeIndex !== undefined
                ? data.sizeIndex
                : null;

        var selectedOptions = (function () {
            var first = variants[0];
            return first ? first.options.slice() : [];
        })();

        function formatMoney(cents) {
            var sym =
                window.Shopify && Shopify.currency
                    ? Shopify.currency.active
                    : "USD";
            return (cents / 100).toLocaleString(undefined, {
                style: "currency",
                currency: sym,
            });
        }

        function findVariant(options) {
            return (
                $.grep(variants, function (v) {
                    return v.options.every(function (opt, i) {
                        return opt === options[i];
                    });
                })[0] || null
            );
        }

        function availableForColor(colorVal) {
            return $.map(
                $.grep(variants, function (v) {
                    return (
                        (colorIndex === null ||
                            v.options[colorIndex] === colorVal) &&
                        v.available
                    );
                }),
                function (v) {
                    return v.options[sizeIndex];
                },
            );
        }

        function goToSlide(index) {
            $slides.removeClass("is-active").attr("aria-hidden", "true");
            $thumbs.removeClass("is-active").attr("aria-selected", "false");
            $slides
                .eq(index)
                .addClass("is-active")
                .attr("aria-hidden", "false");
            $thumbs
                .filter('[data-sp-thumb="' + index + '"]')
                .addClass("is-active")
                .attr("aria-selected", "true");
        }

        function goToMedia(mediaId) {
            $slides.each(function (i, el) {
                if (String($(el).data("media-id")) === String(mediaId)) {
                    goToSlide(i);
                    return false;
                }
            });
        }

        function applyVariant(variant) {
            if (!variant) return;
            var addLabel = $atc.data("add-label") || "Add to cart";
            var naLabel = $atc.data("unavailable-label") || "Unavailable";

            $price.text(formatMoney(variant.price));

            if (
                variant.compare_at_price &&
                variant.compare_at_price > variant.price
            ) {
                $compare.text(formatMoney(variant.compare_at_price)).show();
            } else {
                $compare.hide().text("");
            }

            $atc.prop("disabled", !variant.available).text(
                variant.available ? addLabel : naLabel,
            );
            $select.val(variant.id);

            try {
                var url = new URL(window.location.href);
                url.searchParams.set("variant", String(variant.id));
                window.history.replaceState({}, "", url.toString());
            } catch (err) {}

            if (variant.featured_media && variant.featured_media.id) {
                goToMedia(variant.featured_media.id);
            }
        }

        /* Thumbnails */
        $thumbs.on("click", function () {
            goToSlide(parseInt($(this).data("sp-thumb"), 10));
        });

        /* Color swatches */
        $section.on("click", "[data-sp-swatch]", function () {
            var val = $(this).data("sp-swatch");
            selectedOptions[colorIndex] = val;
            $section.find("[data-sp-swatch]").removeClass("is-selected");
            $(this).addClass("is-selected");
            $colorLabel.text(val);

            var avail = availableForColor(val);
            $section.find("[data-sp-size]").each(function () {
                var sv = $(this).data("sp-size");
                var unavailable = avail.indexOf(sv) === -1;
                $(this)
                    .toggleClass("is-unavailable", unavailable)
                    .prop("disabled", unavailable);
            });

            if (
                sizeIndex !== null &&
                avail.indexOf(selectedOptions[sizeIndex]) === -1
            ) {
                selectedOptions[sizeIndex] = null;
                $section.find("[data-sp-size]").removeClass("is-selected");
                $atc.prop("disabled", true).text("SELECT A SIZE");
                return;
            }
            var v = findVariant(selectedOptions);
            if (v) applyVariant(v);
        });

        /* Size buttons */
        $section.on("click", "[data-sp-size]", function () {
            if ($(this).prop("disabled")) return;
            var val = $(this).data("sp-size");
            selectedOptions[sizeIndex] = val;
            $section.find("[data-sp-size]").removeClass("is-selected");
            $(this).addClass("is-selected");
            var v = findVariant(selectedOptions);
            if (v) applyVariant(v);
        });

        /* Init */
        var init = findVariant(selectedOptions);
        if (init) applyVariant(init);
    }

    $(function () {
        $("[data-sp]").each(function () {
            initProduct($(this));
        });
    });
})(jQuery);
